export interface GameRunStats {
  sessionId: string;
  startedAt: number;
  finishedAt: number | null;
  score: number;
  meteorsPassed: number;
  meteorsDestroyed: number;
  shotsFired: number;
  ammoBonusesCollected: number;
  lifeBonusesCollected: number;
  bonusScore: number;
}

const emptyRun = (): GameRunStats => ({
  sessionId: '',
  startedAt: 0,
  finishedAt: null,
  score: 0,
  meteorsPassed: 0,
  meteorsDestroyed: 0,
  shotsFired: 0,
  ammoBonusesCollected: 0,
  lifeBonusesCollected: 0,
  bonusScore: 0,
});

export class GameRunTracker {
  private run = emptyRun();

  public constructor(
    private readonly createId: () => string = () => crypto.randomUUID(),
    private readonly now: () => number = Date.now,
  ) {}

  public start(): GameRunStats {
    this.run = { ...emptyRun(), sessionId: this.createId(), startedAt: this.now() };
    return this.snapshot;
  }

  public reset(): void {
    this.run = emptyRun();
  }

  public finish(score: number): GameRunStats {
    if (!this.run.sessionId) this.start();
    this.run.score = Math.max(0, Math.floor(score));
    this.run.finishedAt ??= this.now();
    return this.snapshot;
  }

  public recordMeteorPassed(): void {
    this.run.meteorsPassed += 1;
  }

  public recordMeteorDestroyed(): void {
    this.run.meteorsDestroyed += 1;
  }

  public recordShot(): void {
    this.run.shotsFired += 1;
  }

  public recordPowerUp(type: 'ammo' | 'life'): void {
    if (type === 'ammo') this.run.ammoBonusesCollected += 1;
    else this.run.lifeBonusesCollected += 1;
  }

  public recordBonusScore(score: number): void {
    this.run.bonusScore += Math.max(0, Math.floor(score));
  }

  public get snapshot(): GameRunStats {
    return { ...this.run };
  }
}
